import {
  addItemToCollection,
  deleteItemFromCollection,
  fetchEmployees,
  fetchItems,
  updateItemInCollection,
} from "directus/src/operations";
import { DAYS_TO_SHOW } from "./utils";
import { searchName } from "@/api/utils";

export async function fetchCurrentWeekTimesheet() {
  try {
    const query = {
      fields: [
        "approved_hours",
        "date",
        "description",
        "employee.avatar",
        "employee.first_name",
        "employee.id",
        "employee.last_name",
        "id",
        "job.id",
        "job.name",
        "logged_hours",
        "milestone.id",
        "milestone.name",
        "project.id",
        "project.name",
        "unapproved_hours",
      ],
      filter: {
        date: {
          _gte: `$NOW(-${DAYS_TO_SHOW} days)`,
          _lte: "$NOW",
        },
        reviewer: {
          user: {
            _eq: "$CURRENT_USER"
          }
        }
      },
      sort: ["-date"],
    };
    const data = await fetchItems("timesheet", query);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function fetchProjectDailyTimesheet(date) {
  try {
    const query = {
      fields: [
        "id",
        "date",
        "logged_hours",
        "employee.first_name",
        "employee.last_name",
        "employee.id",
        "employee.avatar",
        "approved_hours",
        "unapproved_hours",
        "description",
        "project.id",
        "project.name",
        "job.id",
        "job.name",
        "milestone.id",
        "milestone.name",
      ],
      filter: {
        date: {
          _eq: date,
        },
        _or: [
          {
            project: {
              coordinator: { user: { _eq: "$CURRENT_USER" } },
            },
          },
          {
            job: {
              coordinator: { user: { _eq: "$CURRENT_USER" } },
            },
          },
          {
            milestone: {
              coordinator: { user: { _eq: "$CURRENT_USER" } },
            },
          },
        ],
      },
      sort: ["-date_created"],
    };
    const data = await fetchItems("timesheet", query);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function fetchEmployeesOfCoordinatorsJobs(search = "") {
  try {
    const query = {
      fields: ["first_name", "last_name", "id", "avatar"],
      filter: {
        ...searchName(search),
        jobs_assigned: {
          job: {
            coordinator: { user: { _eq: "$CURRENT_USER" } },
            status: { _eq: "in_progress" },
          },
        },
      },
      sort: ["first_name"],
    };

    const response = fetchEmployees(query);

    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function fetchEmployeesOfJobs(search = "", jobId = null) {
  try {
    // Build jobs_assigned filter based on whether a specific job is selected
    const jobsAssignedFilter = {
      reviewer: { user: { _eq: "$CURRENT_USER" } },
      ...(jobId
        ? { job: { id: { _eq: jobId } } }
        : {
          _or: [
            {
              job: {
                status: { _eq: "in_progress" },

              },
            },
            {
              job: {
                milestones: {
                  status: { _eq: "in_progress" },

                },
              },
            },
          ],
        }),
    };

    const query = {
      fields: ["first_name", "last_name", "id", "avatar"],
      filter: {
        ...searchName(search),
        user: {
          status: { _eq: "active" }
        },
        jobs_assigned: jobsAssignedFilter,
      },
      sort: ["first_name"],
    };

    const response = fetchEmployees(query);

    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
